export const ISDONE = 'ISDONE';

export const getIsDone = (done) => ({
  type: ISDONE,
  done,
});
